import React from "react";
import { useLocation } from "react-router-dom";
import OnboardingLayout from "../../../components/layout/OnboardingLayout";
import SystemBanner from "../../../components/ui/SystemBanner";

const DEFAULT_STEPS = ["Business Details", "Verification", "Done"];

// Offline KYB — shown when the user's account is REJECTED.
// Rejection reasons come from location.state?.reasons if the backend
// passes them; otherwise a generic support message is shown.
// Resubmit is intentionally removed — KYB is handled offline for launch.
const KYBRejected = () => {
  const location = useLocation();
  const reasons = location.state?.reasons || [];

  return (
    <OnboardingLayout steps={DEFAULT_STEPS} currentStep={1}>
      <div className="bg-cardBg border border-cardBorder rounded-card shadow-card p-8">
        <SystemBanner
          type="error"
          message="Your KYB submission could not be approved. Please address the issues below and resubmit."
        />

        <div className="text-center py-4">
          {/* Error icon */}
          <div className="w-16 h-16 bg-statusRedBg rounded-full flex items-center justify-center mx-auto mb-6">
            <svg className="w-8 h-8 text-statusRed" fill="currentColor" viewBox="0 0 20 20">
              <path
                fillRule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                clipRule="evenodd"
              />
            </svg>
          </div>

          <h1 className="text-xl font-bold text-textPrimary mb-2">Verification Unsuccessful</h1>
          <p className="text-sm text-textMuted mb-6">
            Your KYB submission could not be approved. Please address the issues
            below and resubmit.
          </p>

          {/* Issues list when reasons are available from the API */}
          {reasons.length > 0 ? (
            <div className="text-left bg-statusRedBg border border-red-200 rounded-lg p-4 mb-8">
              <p className="text-sm font-semibold text-statusRed mb-3">Issues found</p>
              <ul className="space-y-2">
                {reasons.map((reason, i) => (
                  <li key={i} className="flex items-start gap-2 text-sm text-red-700">
                    <svg
                      className="w-4 h-4 text-statusRed flex-shrink-0 mt-0.5"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                        clipRule="evenodd"
                      />
                    </svg>
                    {reason}
                  </li>
                ))}
              </ul>
            </div>
          ) : (
            <div className="text-left bg-pageBg border border-cardBorder rounded-lg p-4 mb-8">
              <p className="text-sm text-textMuted">
                Please contact our support team to understand the reason for
                rejection and the next steps for resubmission.
              </p>
            </div>
          )}

          <button
            type="button"
            className="btn-outline w-auto px-8 mx-auto"
            onClick={() => window.open("mailto:support@borderless.world", "_blank")}
          >
            Contact Support
          </button>
        </div>
      </div>
    </OnboardingLayout>
  );
};

export default KYBRejected;
